import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import NewsletterSignup from "@/components/NewsletterSignup";
import { api } from "@/lib/api";

export default function Footer() {
    const [latest, setLatest] = useState([]);
    useEffect(() => {
        api.get("/blog").then(({ data }) => setLatest((data || []).slice(0, 4))).catch(() => {});
    }, []);
    return (
        <footer className="bg-brand-ink text-brand-bg" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-5 gap-12">
                <div className="md:col-span-2">
                    <div className="bg-brand-bg inline-block p-5 border border-brand-bg/20 shadow-md">
                        <Logo variant="stacked" />
                    </div>
                    <p className="mt-6 max-w-sm text-sm text-brand-bg/70 leading-relaxed font-light">
                        Société de rénovation d'intérieurs haut de gamme, dédiée à la transformation de vos espaces avec
                        exigence, élégance et précision.
                    </p>
                    <div className="mt-8">
                        <p className="overline mb-3 text-brand-sage">Newsletter</p>
                        <NewsletterSignup />
                    </div>
                    <div className="mt-8 flex items-center gap-4">
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram"
                            className="w-10 h-10 border border-brand-bg/30 flex items-center justify-center hover:bg-brand-sage hover:border-brand-sage transition-colors"
                        >
                            <Instagram size={16} />
                        </a>
                    </div>
                </div>
                <div>
                    <h3 className="overline mb-5 text-brand-sage">Navigation</h3>
                    <ul className="space-y-3 text-sm">
                        <li><Link data-testid="footer-link-approche" to="/approche" className="hover:text-brand-sage transition-colors">Notre approche</Link></li>
                        <li><Link data-testid="footer-link-realisations" to="/realisations" className="hover:text-brand-sage transition-colors">Réalisations</Link></li>
                        <li><Link data-testid="footer-link-blog" to="/blog" className="hover:text-brand-sage transition-colors">Blog</Link></li>
                        <li><Link data-testid="footer-link-devis" to="/devis" className="hover:text-brand-sage transition-colors">Demande de devis</Link></li>
                        <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-brand-sage transition-colors">Contact</Link></li>
                    </ul>
                </div>
                <div>
                    <h3 className="overline mb-5 text-brand-sage">Derniers articles</h3>
                    <ul className="space-y-3 text-sm" data-testid="footer-latest-articles">
                        {latest.length === 0 && (
                            <li className="text-brand-bg/50 italic">Le blog se construit…</li>
                        )}
                        {latest.map((a) => (
                            <li key={a.id}>
                                <Link to={`/blog/${a.slug}`} className="hover:text-brand-sage transition-colors line-clamp-2 leading-snug">
                                    {a.title}
                                </Link>
                            </li>
                        ))}
                        {latest.length > 0 && (
                            <li className="pt-2">
                                <Link to="/blog" className="text-xs uppercase tracking-[0.2em] text-brand-sage hover:underline">Tous les articles →</Link>
                            </li>
                        )}
                    </ul>
                </div>
                <div>
                    <h3 className="overline mb-5 text-brand-sage">Contact</h3>
                    <ul className="space-y-4 text-sm text-brand-bg/80">
                        <li className="flex items-start gap-3">
                            <Mail size={14} className="mt-1 shrink-0 text-brand-sage" />
                            <a href="mailto:contact@japet-agencement.fr" data-testid="footer-email" className="hover:text-brand-bg">contact@japet-agencement.fr</a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Phone size={14} className="mt-1 shrink-0 text-brand-sage" />
                            <span>Sur rendez-vous uniquement</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin size={14} className="mt-1 shrink-0 text-brand-sage" />
                            <span>Île-de-France & Paris</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-brand-bg/15">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-bg/60">
                    <p>© {new Date().getFullYear()} Japet Agencement. Tous droits réservés.</p>
                    <div className="flex items-center gap-6">
                        <Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-brand-bg">Mentions légales</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
